export const CurrencyFormatId = {
  US: 1,
  FRACTIONAL: 2,
  DECIMAL: 3,
  INDONESIAN: 5,
  CHINESE: 6,
};
